module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-upload', {
    ref: "upload",
    attrs: {
      "action": "none",
      "multiple": _vm.multiple,
      "accept": _vm.accept,
      "file-list": _vm.postData,
      "on-preview": _vm.onPreview,
      "on-remove": _vm.onRemove,
      "on-success": _vm.onSuccess,
      "on-error": _vm.onError,
      "on-progress": _vm.onProgress,
      "on-change": _vm.onChange,
      "on-exceed": _vm.onExceed,
      "before-upload": _vm.beforeUpload,
      "http-request": _vm.uploadFile,
      "limit": _vm.limit,
      "disabled": _vm.disabled
    }
  }, [(_vm.postData.length < _vm.limit ? true : false) ? _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_vm._v(_vm._s(_vm.$T('点击上传')))]) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c415c984","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/picker/FileUploader.vue
// module id = 1581
// module chunks = 0